/**
 * Convert kgCO2 to teCO2.
 * And round the result with 2 decimals.
 */
export function convertCo2Score(score: number): number {
  const valueKgCo2 = score;
  const valueTeCo2 = valueKgCo2 / 1000;
  const valueTeCo2RoundedString: string = valueTeCo2.toFixed(2); // Rounds 13.4542 => 14.45
  // toFixed() returns a string, let's convert it back to number
  const valueTeCo2Rounded: number = Number(valueTeCo2RoundedString);
  return valueTeCo2Rounded;
}

/**
 * Convert kgCO2 to teCO2.
 * And round the result with 2 decimals.
 */
export function convertCo2ScoreString(score: string): string {
  if (score === '') {
    return '_';
  }
  const kgCo2String = score;
  const kgCo2Number: number = Number(kgCo2String);
  const teCo2Number: number = kgCo2Number / 1000;
  const teCo2String: string = teCo2Number.toFixed(2);
  return teCo2String;
}
